module.exports = __webpack_public_path__ + "img/hem.bfd28311.jpg";